import { styled } from "@mui/material/styles";

const RouteStepMain = styled("div")(({ theme }) => ({
  marginTop: "35px",
  paddingBottom: "40px",
  [theme.breakpoints.down("md")]: {
    paddingBottom: "30px",
  },
}));
const InputFlexWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "5px",
  gap: "20px",
  "& .AuthInputMain": { width: "100%" },
  "&.CargoNameFlexWrap": {
    gap: "10px",
    width: "100%",
    "& .AuthInputMain:first-of-type": { width: "100%" },
    "& .AuthInputMain:last-child": { width: "70%" },
    [theme.breakpoints.down("md")]: {
      gap: "5px",
      flexDirection: "row",
    },
  },
  "& .DimensionsFlexWrap": {
    gap: "10px",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      gap: "5px",
      flexDirection: "row",
    },
  },
  flexDirection: "row",
  [theme.breakpoints.down("md")]: {
    gap: "5px",
    flexDirection: "column",
  },
}));

const CargoDescription = styled("div")(({ theme }) => ({
  marginTop: "25px",
  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& textarea": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    width: "100%",
    background: "#F2F2F2",
    borderRadius: "10px",
    border: "none",
    padding: "10px",
    resize: "none",
    height: "140px",
    fontFamily: theme.typography.fontFamily,
  },
  "&.haveBorder textarea": { border: "1px solid red" },
}));

const ErrorSpan = styled("span")(({ theme }) => ({
  color: "red",
  fontWeight: 400,
  fontSize: "14px",
  fontFamily: theme.typography.fontFamily,
}));

const FileUploadWrap = styled("div")(({ theme }) => ({
  width: "100%",
  position: "relative",
  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    "& span.ButtonLabel": {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
  },
  "& .MuiButtonBase-root": {
    display: "flex",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    height: "48px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    boxShadow: "none",
    textTransform: "inherit",
    "&:hover": { background: "#F2F2F2" },
  },
  "& .ButtonContainer": {
    display: "flex",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    height: "48px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    boxShadow: "none",
    textTransform: "inherit",
    "&:hover": { background: "#F2F2F2" },
  },
  "& .css-qqctjx-MuiButtonBase-root-MuiButton-root": {
    display: "flex",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    height: "48px",
    lineHeight: "25px",
    color: "rgba(11, 11, 11, 0.6)",
    boxShadow: "none",
    textTransform: "inherit",
    "&:hover": { background: "#F2F2F2" },
  },
  "& .errorSpan": { position: "absolute", top: "100%", left: "0" },
  [theme.breakpoints.down("md")]: {
    marginBottom: "15px",
  },
}));

const DateTimeWrap = styled("div")(({ theme }) => ({
  position: "relative",
  "& label": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  width: "100%",
  "& .react-datepicker-wrapper": {
    display: "block",
  },
  "& .react-datepicker__input-container": {
    width: "100%",
  },
  "& .react-datepicker__input-container input": {
    width: "100%",
    height: "48px",
    padding: "8px",
    background: "#F2F2F2",
    borderRadius: "10px",
    fontSize: "16px",
    border: "none",
    fontFamily: theme.typography.fontFamily,
  },
  "& .errorSpan": {
    position: "absolute",
    top: "100%",
    left: "0",
  },
}));

export {
  RouteStepMain,
  InputFlexWrap,
  CargoDescription,
  ErrorSpan,
  FileUploadWrap,
  DateTimeWrap,
};
